import { useEffect } from 'react';

interface UseClientConsentCompletionProps {
  isClientConsentFlow: boolean;
  isConsentPending: boolean;
  isPacketDownloaded: boolean;
  onCompletionChange?: (isComplete: boolean) => void;
}

export function useClientConsentCompletion({
  isClientConsentFlow,
  isConsentPending,
  isPacketDownloaded,
  onCompletionChange,
}: UseClientConsentCompletionProps) {
  const isComplete = isClientConsentFlow && !isConsentPending && isPacketDownloaded;

  useEffect(() => {
    onCompletionChange?.(isComplete);
  }, [isComplete, onCompletionChange]);

  return isComplete;
}
